import { render, staticRenderFns } from "./faq_section_desktop.vue?vue&type=template&id=16e9bc1c&scoped=true"
import script from "./faq_section_desktop.vue?vue&type=script&lang=js"
export * from "./faq_section_desktop.vue?vue&type=script&lang=js"
import style0 from "./faq_section_desktop.vue?vue&type=style&index=0&id=16e9bc1c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e9bc1c",
  null
  
)

export default component.exports